// @ts-check

import React from 'react';
import { array, func, object } from 'prop-types';
import USER from '../ts/profileEditorEnum';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

/**
 * @component LanguageSelector
 * @param {Object} props
 * @param {LanguageType[]} props.values
 * @param {LanguageType[]} props.options
 * @param {EditorValidType} props.valid
 * @param {(name:string, payload:any) => void} props.onHandleUser
 * @returns {JSX.Element}
 */
function LanguageSelector({ values, options, valid, onHandleUser }) {
	return (
		<Autocomplete
			fullWidth
			multiple
			value={values}
			options={options}
			// @ts-ignore
			getOptionLabel={(option) => (option.name ? option.name : '')}
			onChange={(e, newValue) => onHandleUser(USER.LANGUAGES, newValue)}
			renderInput={(params) => (
				<TextField
					{...params}
					variant="outlined"
					label="Language"
					InputLabelProps={{ shrink: true }}
					size="small"
					error={valid.hasErr}
					helperText={valid.msg}
				/>
			)}
		/>
	);
}

LanguageSelector.propTypes = {
	values: array,
	options: array,
	valid: object,
	onHandleUser: func,
};

export default LanguageSelector;
